import React, { useEffect, useState, createContext, useContext } from 'react';
export type Language = 'en' | 'id' | 'ar' | 'zh' | 'fr' | 'ru' | 'es';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [language, setLanguageState] = useState<Language>('en');
  const [translations, setTranslations] = useState<Record<string, string>>({});
  useEffect(() => {
    // Load saved language from localStorage
    const savedLang = localStorage.getItem('language') as Language;
    if (savedLang && ['en', 'id', 'ar', 'zh', 'fr', 'ru', 'es'].includes(savedLang)) {
      setLanguageState(savedLang);
    }
  }, []);
  useEffect(() => {
    // Load translations for current language
    import(`../locales/${language}.json`).then(module => setTranslations(module.default)).catch(() => setTranslations({}));
  }, [language]);
  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    localStorage.setItem('language', lang);
    // Update HTML lang attribute
    document.documentElement.lang = lang;
    // Update dir attribute for RTL languages
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
  };
  const t = (key: string): string => {
    return translations[key] || key;
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t
  }} data-id="element-658">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}